import './App.css';
import { useNavigate } from 'react-router-dom';
import { menu } from './Dash';
import { getEnterpriseInfo } from './Functions';
import myImage from "./logo.jpeg"


function Intro() {
  const navigate = useNavigate();
  return (
    <div className="center bg-color-primary all-viewport">

<div style={{position:'fixed', left:0, top:0,  height:'100%', width:'10%', backgroundColor:'white', zIndex: 20}}>
        {
           menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
                className='center'
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'15px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )}
      </div>
      <div className='center' style={{width:'90%', flexDirection:'column', height:'50%', marginBottom:'10%', backgroundColor:''}}>
        <div className='center' style={{ width:'35%', marginBottom:'20px', backgroundColor:''}}><img style={{width:'70%'}} src={myImage} alt="Descrizione immagine" /></div>
        <div className='text-color-one' style={{ fontFamily:'monospace', fontSize:'23px', fontWeight:'bold' }} > Cash Flow</div>
      </div>
    </div>
  );
}

export default Intro;
